// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.
import React, { useState, useEffect } from "react";
import Header from "../../component/_elements/Header.tsx";
import { useOutletContext } from "react-router-dom";
import { OutletContextType } from "../../types/GlobalType.ts";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  messageControler,
  MessageType,
} from "../../_api/controllers/message.controller.ts";
import moment from "moment";
import { capitalizeFirstLetter } from "../../_services/utils.jsx";
import { studentControler } from "../../_api/controllers/student.controller.ts";
import {
  classeController,
  promotionController,
  schoolYearController,
} from "../../_api/controllers/scolarite.controller.ts";
import { personalController } from "../../_api/controllers/personal.controller.ts";
import { parentController } from "../../_api/controllers/parent.controller.ts";
import { EHULA_CONTACT } from "../../App.constants.js";
const Message: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  const [currentYear, setCurrentYear] = useState("2025 - 2026");
  const [isYearDropdownOpen, setIsYearDropdownOpen] = useState(false);
  const [showViewMessageModal, setShowViewMessageModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedDestinateur, setSelectedDestinateur] = useState(
    "Tous les destinateurs"
  );
  const [selectedType, setSelectedType] = useState("Tous les types");
  const [selectedStatus, setSelectedStatus] = useState("Tous les statuts");
  const [isClassDropdownOpen, setIsDestinateurDropdownOpen] = useState(false);
  const [isTypeDropdownOpen, setIsTypeDropdownOpen] = useState(false);
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const [viewMode, setViewMode] = useState("liste");
  const [showNewMessageModal, setShowNewMessageModal] = useState(false);
  const [showEditMessageModal, setShowEditMessageModal] = useState(false);
  const [messageToEdit, setMessageToEdit] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [messageToDelete, setMessageToDelete] = useState<any>(null);

  const [notification, setNotification] = useState<any>(null); // { message, type }
  // Fonction pour afficher une notification
  const showNotification = (message: string, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  // const [showNotification, setShowNotification] = useState(false);
  // const [notificationMessage, setNotificationMessage] = useState<string>("");
  const [createMessageForm, setcreateMessageForm] = useState<{
    objet: any;
    contenu: string;
    type_destinateur:
      | "parents"
      | "parents_class"
      | "single_parent"
      | "personals"
      | "single_personal"
      | string;
    destinateur_id: any;
    annee_scolaire_id?: any;
    type_diffuison?: any | "individual" | "groupe";
    canal: "email" | "sms";
    type_request:
      | any
      | "sms_all_parents"
      | "sms_parents_class"
      | "sms_one_parent"
      | "email_all_parents"
      | "email_parents_class"
      | "email_one_parent"
      | "sms_all_personals"
      | "sms_one_personal"
      | "email_all_personals"
      | "email_one_personal";

    status: any;
  }>({
    objet: "",
    contenu: "",
    type_destinateur: "parents",
    destinateur_id: "",
    annee_scolaire_id: "",
    type_diffuison: "",
    canal: "email",
    type_request: null,
    status: 0,
  });

  const getRequestType = ():
    | "sms_all_parents"
    | "sms_parents_class"
    | "sms_one_parent"
    | "email_all_parents"
    | "email_parents_class"
    | "email_one_parent"
    | "sms_all_personals"
    | "sms_one_personal"
    | "email_all_personals"
    | "email_one_personal" => {
    let request_name: any = null;

    switch (createMessageForm.canal) {
      case "sms":
        switch (createMessageForm.type_destinateur) {
          case "parents":
            if (createMessageForm.destinateur_id === "all") {
              request_name = "sms_all_parents";
            }
            return request_name;
          case "parents_class":
            if (
              createMessageForm.destinateur_id !== "all" &&
              createMessageForm.destinateur_id !== ""
            ) {
              request_name = "sms_parents_class";
            }
            return request_name;
          case "single_parent":
            if (createMessageForm.destinateur_id !== "") {
              request_name = "sms_one_parent";
            }
            return request_name;
          case "personals":
            if (
              createMessageForm.destinateur_id === "all" &&
              createMessageForm.destinateur_id !== ""
            ) {
              request_name = "sms_all_personals";
            }
            return request_name;
          case "single_personal":
            if (
              createMessageForm.destinateur_id !== "" &&
              createMessageForm.destinateur_id !== "all"
            ) {
              request_name = "sms_one_personal";
            }
            return request_name;
          default:
            break;
        }
        break;
      case "email":
        switch (createMessageForm.type_destinateur) {
          case "parents":
            if (createMessageForm.destinateur_id === "all") {
              request_name = "email_all_parents";
            }
            break;
          case "parents_class":
            if (
              createMessageForm.destinateur_id !== "all" &&
              createMessageForm.destinateur_id !== ""
            ) {
              request_name = "email_parents_class";
            }
            break;
          case "single_parent":
            if (createMessageForm.destinateur_id !== "") {
              request_name = "email_one_parent";
            }
            break;
          case "personals":
            if (
              createMessageForm.destinateur_id === "all" &&
              createMessageForm.destinateur_id !== ""
            ) {
              request_name = "email_all_personals";
            }
            break;
          case "single_personal":
            if (
              createMessageForm.destinateur_id !== "" &&
              createMessageForm.destinateur_id !== "all"
            ) {
              request_name = "email_one_personal";
            }
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }

    return request_name;
  };
  //get The request name dependant of url send message
  getRequestType();

  //fetch all messages
  const { data: messagesData } = useQuery({
    queryKey: ["messages"],
    queryFn: messageControler.getAll,
  });
  //fetch eleves
  const { data: elevesData } = useQuery({
    queryKey: ["students"],
    queryFn: studentControler.getAll,
  });

  //fetch classe
  const { data: classesData } = useQuery({
    queryKey: ["classes"],
    queryFn: classeController.getAll,
  });

  const { data: promotionData } = useQuery({
    queryKey: ["promotions"],
    queryFn: promotionController.getAll,
  });

  //fetch active schoolYear scolaire
  const { data: schoolYearActiveData } = useQuery({
    queryKey: ["activeSchoolYears"],
    queryFn: schoolYearController.getActive,
  });

  //fetch all Personals
  const { data: personalsData } = useQuery({
    queryKey: ["personals"],
    queryFn: personalController.getAll,
  });
  //fetch all parents
  const { data: parentsData } = useQuery({
    queryKey: ["parents"],
    queryFn: parentController.getAll,
  });

  const messagesArray = messagesData?.data ? messagesData.data : [];
  const studentsArray = elevesData?.data ? elevesData.data : [];
  const classesArray = classesData?.data ? classesData.data : [];
  const promotionsArray = promotionData?.data ? promotionData.data : [];
  const personalsArray = personalsData?.data ? personalsData.data : [];
  const parentsArray = parentsData?.data ? parentsData.data : [];
  const schoolYearActiveDataArr = schoolYearActiveData?.data
    ? schoolYearActiveData.data
    : [];

  //prepare affected students data
  const affectedStudents = studentsArray.map((student) => {
    let classeDesignation = "",
      parentEmail = "",
      parentPhone = "",
      parentId: any = "",
      promotionData: any = "",
      classeId: any = "";

    for (const promo of promotionsArray) {
      if (
        student.eleve_id === promo.eleve_id &&
        promo.annee_scolaire_id === schoolYearActiveDataArr[0]?.id
      ) {
        promotionData = promo; //filter the promotion of the student for the active school year

        for (const parent of parentsArray) {
          if (parent.id === student.parent_id) {
            parentEmail = parent?.email || EHULA_CONTACT.EMAIL;
            parentPhone = parent.telephone || EHULA_CONTACT.PHONE;
            parentId = parent.id;
            //Affecter
          }
        }
      }
    }

    for (const classe of classesArray) {
      if (promotionData?.classe_id === classe.id) {
        classeDesignation = classe.designation;
        classeId = classe.id;
      }
    }

    return {
      noms: `${student.nom} ${student.postnom} ${capitalizeFirstLetter(
        student.prenom
      )}`,
      classeDesignation,
      nom: student.nom,
      postnom: student.postnom,
      prenom: student.prenom,
      classeId,
      parentId,
      parentEmail,
      parentPhone,
    };
  });

  // console.log(affectedStudents);
  const affectedPersonals = personalsArray.map((personal) => {
    return {
      personalId: personal.personnel_id,
      noms: `${personal.nom} ${personal.postnom} ${capitalizeFirstLetter(
        personal.prenom
      )}`,
      email: personal.email || EHULA_CONTACT.EMAIL,
      phone: personal.telephone || EHULA_CONTACT.PHONE,
    };
  });

  const messagesPerPage = 10;
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };
  const toggleYearDropdown = () => {
    setIsYearDropdownOpen(!isYearDropdownOpen);
  };
  const toggleClassDropdown = () => {
    setIsDestinateurDropdownOpen(!isClassDropdownOpen);
    if (isClassDropdownOpen) {
      setIsTypeDropdownOpen(false);
      setIsStatusDropdownOpen(false);
    }
  };
  const toggleTypeDropdown = () => {
    setIsTypeDropdownOpen(!isTypeDropdownOpen);
    if (isTypeDropdownOpen) {
      setIsDestinateurDropdownOpen(false);
      setIsStatusDropdownOpen(false);
    }
  };
  const toggleStatusDropdown = () => {
    setIsStatusDropdownOpen(!isStatusDropdownOpen);
    if (isStatusDropdownOpen) {
      setIsDestinateurDropdownOpen(false);
      setIsTypeDropdownOpen(false);
    }
  };

  const completeMessage = messagesArray.map((message: MessageType, index) => {
    let canalType =
      message.canal_mail === 1
        ? "Email"
        : message.canal_sms === 1
        ? "SMS"
        : message.canal_notification === 1
        ? "Soft SMS"
        : "Unset";
    return {
      id: index + 1,
      date: moment(message.created_at).format("DD/MM/YYYY"),
      heure: moment(message.created_at).format("HH:mm"),
      objet: capitalizeFirstLetter(message.objet),
      contenu: message.contenu,
      destinataires:
        message.type_destinateur_id === 1 ? "Parent" : "Professeur",
      classe: message.type_diffusion === "groupe" ? "Tous" : "Individuel",
      type: canalType,
      statut: message.status === 1 ? "Envoyé" : "Brouillon",
      // lu: 28,
      // nonLu: 2,
    };
  });
  // Données des communications
  const communications: any[] = [...completeMessage];

  // Filtrer les communications selon la recherche et les filtres
  const filteredCommunications = communications.filter((communication) => {
    const matchesSearch =
      communication.objet.toLowerCase().includes(searchQuery.toLowerCase()) ||
      communication.contenu.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesDestinateur =
      selectedDestinateur === "Tous les destinateurs" ||
      communication.destinataires === selectedDestinateur;
    const matchesType =
      selectedType === "Tous les types" || communication.type === selectedType;
    const matchesStatus =
      selectedStatus === "Tous les statuts" ||
      communication.statut === selectedStatus;
    return matchesSearch && matchesDestinateur && matchesType && matchesStatus;
  });
  const indexOfLastMessage = currentPage * messagesPerPage;
  const indexOfFirstMessage = indexOfLastMessage - messagesPerPage;
  const currentMessages = filteredCommunications.slice(
    indexOfFirstMessage,
    indexOfLastMessage
  );
  const totalPages = Math.ceil(filteredCommunications.length / messagesPerPage);
  const handlePageChange = (pageNumber: number) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleChangeDestinateur = (e: React.ChangeEvent<HTMLInputElement>) => {
    setcreateMessageForm((prev) => ({
      ...prev,
      type_destinateur: e.target.value,
      destinateur_id: "",
    }));
  };

  console.log(getRequestType());

  const handleResetFilter = () => {
    setSelectedType("Tous les types");
    setSelectedStatus("Tous les statuts");
    setSelectedDestinateur("Tous les destinateurs");
  };

  // Fonction pour exporter les données
  const exportData = () => {
    const data = communications.map((communication: any) => ({
      Date: communication.date,
      Objet: communication.objet,
      Contenu: communication.contenu,
      Destinataires: communication.destinataires,
      Type: communication.type,
      Statut: communication.statut,
    }));

    // Create Excel-like content
    const headers = Object.keys(data[0]);
    const excelContent = [
      headers.join("\t"),
      ...data.map((row: any) =>
        headers.map((header) => row[header]).join("\t")
      ),
    ].join("\n");
    // Create and trigger download
    const blob = new Blob([excelContent], {
      type: "text/tab-separated-values;charset=utf-8;",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Communique_${new Date().toISOString().split("T")[0]}.xls`;
    link.click();

    showNotification("Export Excel réussi");
  };

  //Handle mouse click outside for dropdowns
  const destinateurDropdownRef = React.useRef<HTMLDivElement>(null);
  const typeDropdownRef = React.useRef<HTMLDivElement>(null);
  const statusDropdownRef = React.useRef<HTMLDivElement>(null);
  // Fermeture des menus lors d'un clic à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      //export button
      if (
        destinateurDropdownRef.current &&
        !destinateurDropdownRef.current.contains(event.target as Node)
      ) {
        setIsDestinateurDropdownOpen(false);
      }

      //class button
      if (
        typeDropdownRef.current &&
        !typeDropdownRef.current.contains(event.target as Node)
      ) {
        setIsTypeDropdownOpen(false);
      }

      //status button
      if (
        statusDropdownRef.current &&
        !statusDropdownRef.current.contains(event.target as Node)
      ) {
        setIsStatusDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //Mutation pour envoyer
  const queryClient = useQueryClient();

  //NOT DONE SEE THE BACK-END
  const mutationsendEMAILtoAllParents = useMutation({
    mutationFn: () =>
      messageControler.sendEMAILtoAllParents({
        objet: createMessageForm.objet,
        message: createMessageForm.contenu,
      }),

    onSuccess: (data) => {
      console.log(data);
      setShowNewMessageModal(false);
      setcreateMessageForm({
        objet: "",
        contenu: "",
        type_destinateur: "parents",
        destinateur_id: "",
        annee_scolaire_id: "",
        type_diffuison: "",
        canal: "email",
        type_request: null,
        status: 0,
      });
      showNotification("Message envoyé avec succès", "success");
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },

    onError: () => {
      showNotification("Une erreur s'est produite, réessayer", "erreur");
    },
  });
  //NOT DONE SEE THE BACK-END
  const mutationsendEMAILtoAllPersonals = useMutation({
    mutationFn: () =>
      messageControler.sendEMAILtoAllPersonals({
        objet: createMessageForm.objet,
        message: createMessageForm.contenu,
      }),

    onSuccess: (data) => {
      console.log(data);
      setShowNewMessageModal(false);
      setcreateMessageForm({
        objet: "",
        contenu: "",
        type_destinateur: "parents",
        destinateur_id: "",
        annee_scolaire_id: "",
        type_diffuison: "",
        canal: "email",
        type_request: null,
        status: 0,
      });
      showNotification("Message envoyé avec succès", "success");
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },

    onError: () => {
      showNotification("Une erreur s'est produite, réessayer", "erreur");
    },
  });
  //NOT DONE SEE THE BACK-END
  const mutationsendSMStoAllParents = useMutation({
    mutationFn: () =>
      messageControler.sendSMStoAllParents({
        objet: createMessageForm.objet,
        message: createMessageForm.contenu,
      }),

    onSuccess: (data) => {
      console.log(data);
      setShowNewMessageModal(false);
      setcreateMessageForm({
        objet: "",
        contenu: "",
        type_destinateur: "parents",
        destinateur_id: "",
        annee_scolaire_id: "",
        type_diffuison: "",
        canal: "email",
        type_request: null,
        status: 0,
      });
      showNotification("Message envoyé avec succès", "success");
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },

    onError: () => {
      showNotification("Une erreur s'est produite, réessayer", "erreur");
    },
  });
  //NOT DONE SEE THE BACK-END
  const mutationSMStoAllPersonals = useMutation({
    mutationFn: () =>
      messageControler.sendSMStoAllPersonals({
        objet: createMessageForm.objet,
        message: createMessageForm.contenu,
      }),

    onSuccess: (data) => {
      console.log(data);
      setShowNewMessageModal(false);
      setcreateMessageForm({
        objet: "",
        contenu: "",
        type_destinateur: "parents",
        destinateur_id: "",
        annee_scolaire_id: "",
        type_diffuison: "",
        canal: "email",
        type_request: null,
        status: 0,
      });
      showNotification("Message envoyé avec succès", "success");
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },

    onError: () => {
      showNotification("Une erreur s'est produite, réessayer", "erreur");
    },
  });
  //NOT DONE SEE THE BACK-END
  const mutationsendEMAILtoParentsByClass = useMutation({
    mutationFn: () =>
      messageControler.sendEMAILtoParentsByClass({
        objet: createMessageForm.objet,
        message: createMessageForm.contenu,
        classe_id: createMessageForm.destinateur_id,
        annee_scolaire_id: schoolYearActiveDataArr[0]?.id,
      }),

    onSuccess: (data) => {
      console.log(data);
      setShowNewMessageModal(false);
      setcreateMessageForm({
        objet: "",
        contenu: "",
        type_destinateur: "parents",
        destinateur_id: "",
        annee_scolaire_id: "",
        type_diffuison: "",
        canal: "email",
        type_request: null,
        status: 0,
      });
      showNotification("Message envoyé avec succès", "success");
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },

    onError: () => {
      showNotification("Une erreur s'est produite, réessayer", "erreur");
    },
  });
  //NOT DONE SEE THE BACK-END
  const mutationsendSMStoParentsByClass = useMutation({
    mutationFn: () =>
      messageControler.sendSMStoParentsByClass({
        objet: createMessageForm.objet,
        message: createMessageForm.contenu,
        classe_id: createMessageForm.destinateur_id,
        annee_scolaire_id: schoolYearActiveDataArr[0]?.id,
      }),

    onSuccess: (data) => {
      console.log(data);
      setShowNewMessageModal(false);
      setcreateMessageForm({
        objet: "",
        contenu: "",
        type_destinateur: "parents",
        destinateur_id: "",
        annee_scolaire_id: "",
        type_diffuison: "",
        canal: "email",
        type_request: null,
        status: 0,
      });
      showNotification("Message envoyé avec succès", "success");
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },

    onError: () => {
      showNotification("Une erreur s'est produite, réessayer", "erreur");
    },
  });
  //NOT DONE SEE THE BACK-END
  const mutationsendSMStoOneParent = useMutation({
    mutationFn: () =>
      messageControler.sendSMStoOneParent({
        objet: createMessageForm.objet,
        message: createMessageForm.contenu,
        parent_id: createMessageForm.destinateur_id,
      }),

    onSuccess: (data) => {
      setShowNewMessageModal(false);
      setcreateMessageForm({
        objet: "",
        contenu: "",
        type_destinateur: "parents",
        destinateur_id: "",
        annee_scolaire_id: "",
        type_diffuison: "",
        canal: "email",
        type_request: null,
        status: 0,
      });
      showNotification("Message envoyé avec succès", "success");
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },

    onError: (err) => {
      showNotification("Une erreur s'est produite, réessayer", "erreur");
    },
  });
  //NOT DONE SEE THE BACK-END
  const mutationsendSMStoOnePersonal = useMutation({
    mutationFn: () =>
      messageControler.sendSMStoOnePersonal({
        objet: createMessageForm.objet,
        message: createMessageForm.contenu,
        personnel_id: createMessageForm.destinateur_id,
      }),

    onSuccess: (data) => {
      console.log(data);
      setShowNewMessageModal(false);
      setcreateMessageForm({
        objet: "",
        contenu: "",
        type_destinateur: "parents",
        destinateur_id: "",
        annee_scolaire_id: "",
        type_diffuison: "",
        canal: "email",
        type_request: null,
        status: 0,
      });
      showNotification("Message envoyé avec succès", "success");
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },

    onError: () => {
      showNotification("Une erreur s'est produite, réessayer", "erreur");
    },
  });
  //Done
  const mutationsendEMAILtoOneParent = useMutation({
    mutationFn: () =>
      messageControler.sendEMAILtoOneParent({
        objet: createMessageForm.objet,
        message: createMessageForm.contenu,
        parent_id: createMessageForm.destinateur_id,
      }),

    onSuccess: (data) => {
      console.log(data);
      setShowNewMessageModal(false);
      setcreateMessageForm({
        objet: "",
        contenu: "",
        type_destinateur: "parents",
        destinateur_id: "",
        annee_scolaire_id: "",
        type_diffuison: "",
        canal: "email",
        type_request: null,
        status: 0,
      });
      showNotification("Message envoyé avec succès", "success");
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },

    onError: () => {
      showNotification("Une erreur s'est produite, réessayer", "erreur");
    },
  });
  //DONE
  const mutationsendEMAILtoOnePersonal = useMutation({
    mutationFn: () =>
      messageControler.sendEMAILtoOnePersonal({
        objet: createMessageForm.objet,
        message: createMessageForm.contenu,
        personnel_id: createMessageForm.destinateur_id,
      }),

    onSuccess: (data) => {
      console.log(data);
      setShowNewMessageModal(false);
      setcreateMessageForm({
        objet: "",
        contenu: "",
        type_destinateur: "parents",
        destinateur_id: "",
        annee_scolaire_id: "",
        type_diffuison: "",
        canal: "email",
        type_request: null,
        status: 0,
      });
      showNotification("Message envoyé avec succès", "success");
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },

    onError: () => {
      showNotification("Une erreur s'est produite, réessayer", "erreur");
    },
  });

  const handleSendMessage = () => {
    if (
      !createMessageForm.objet ||
      !createMessageForm.contenu ||
      !createMessageForm.destinateur_id
    )
      return showNotification("Tous les champs sont obligatoire", "erreur");

    switch (getRequestType()) {
      case "sms_all_parents":
        mutationsendSMStoAllParents.mutate();
        break;
      case "email_all_parents":
        mutationsendEMAILtoAllParents.mutate();
        break;
      case "sms_parents_class":
        mutationsendSMStoParentsByClass.mutate();
        break;
      case "email_parents_class":
        mutationsendEMAILtoParentsByClass.mutate();
        break;
      case "sms_one_parent":
        mutationsendSMStoOneParent.mutate();
        break;
      case "email_one_parent":
        mutationsendEMAILtoOneParent.mutate();
        break;
      case "sms_all_personals":
        mutationSMStoAllPersonals.mutate();
        break;
      case "email_all_personals":
        mutationsendEMAILtoAllPersonals.mutate();
        break;
      case "sms_one_personal":
        mutationsendSMStoOnePersonal.mutate();
        break;
      case "email_one_personal":
        mutationsendEMAILtoOnePersonal.mutate();
        break;

      default:
        break;
    }
  };

  const isPending =
    mutationsendSMStoAllParents.isPending ||
    mutationsendSMStoParentsByClass.isPending ||
    mutationsendSMStoOneParent.isPending ||
    mutationsendEMAILtoAllParents.isPending ||
    mutationsendEMAILtoParentsByClass.isPending ||
    mutationsendEMAILtoOneParent.isPending ||
    mutationSMStoAllPersonals.isPending ||
    mutationsendSMStoOnePersonal.isPending ||
    mutationsendEMAILtoAllPersonals.isPending ||
    mutationsendEMAILtoOnePersonal.isPending;

  return (
    <div className="ml-60 w-full">
      {/* Header */}
      <Header
        isDarkMode={isDarkMode}
        setIsDarkMode={setIsDarkMode}
        toggleDarkMode={toggleDarkMode}
        currentYear={currentYear}
        isYearDropdownOpen={isYearDropdownOpen}
        toggleYearDropdown={toggleYearDropdown}
        setCurrentYear={setCurrentYear}
        setIsYearDropdownOpen={setIsYearDropdownOpen}
      />
      {/* Communications Management Content */}
      <main className="p-6 mt-16">
        <div className="mb-6 flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold mb-1">
              Gestion des Communications
            </h1>
            <p className={`${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
              Gérez les messages et communications avec les parents d'élèves
            </p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={() => setShowNewMessageModal(true)}
              className={`flex items-center px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-blue-600 hover:bg-blue-700"
                  : "bg-blue-500 hover:bg-blue-600"
              } text-white !rounded-button whitespace-nowrap`}
            >
              <i className="fas fa-plus mr-2"></i>
              <span>Nouveau Communiqué</span>
            </button>
            <button
              className={`flex items-center px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-gray-100 hover:bg-gray-200"
              } !rounded-button whitespace-nowrap`}
              onClick={exportData}
            >
              <i className="fas fa-file-export mr-2"></i>
              <span>Exporter</span>
            </button>
          </div>
        </div>
        {/* Search and Filters */}
        <div className="flex flex-wrap gap-4 mb-6">
          <div className="flex-grow relative">
            <div
              className={`absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500`}
            >
              <i className="fas fa-search"></i>
            </div>
            <input
              type="text"
              placeholder="Rechercher un message..."
              className={`w-full pl-10 pr-4 py-2 rounded-md text-sm ${
                isDarkMode
                  ? "bg-[#161B22] border-gray-700"
                  : "bg-white border-gray-300"
              } border focus:outline-none focus:ring-2 focus:ring-blue-500`}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          {/* Class Filter */}
          <div className="relative">
            <button
              onClick={toggleClassDropdown}
              className={`flex items-center px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap`}
            >
              <span>{selectedDestinateur}</span>
              <i className="fas fa-chevron-down ml-2"></i>
            </button>
            {isClassDropdownOpen && (
              <div
                className={`absolute top-full right-0 mt-1 w-48 rounded-md shadow-lg ${
                  isDarkMode ? "bg-[#161B22]" : "bg-white"
                } z-10 border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                }`}
                ref={destinateurDropdownRef}
              >
                <div className="py-1">
                  <button
                    onClick={() => {
                      setSelectedDestinateur("Tous les destinateurs");
                      setIsDestinateurDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Tous les destinateurs
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDestinateur("Parents");
                      setIsDestinateurDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Parents
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDestinateur("Professeurs");
                      setIsDestinateurDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Personals
                  </button>
                </div>
              </div>
            )}
          </div>
          {/* Type Filter */}
          <div className="relative">
            <button
              onClick={toggleTypeDropdown}
              className={`flex items-center px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap`}
            >
              <span>{selectedType}</span>
              <i className="fas fa-chevron-down ml-2"></i>
            </button>
            {isTypeDropdownOpen && (
              <div
                className={`absolute top-full right-0 mt-1 w-48 rounded-md shadow-lg ${
                  isDarkMode ? "bg-[#161B22]" : "bg-white"
                } z-10 border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                }`}
                ref={typeDropdownRef}
              >
                <div className="py-1">
                  <button
                    onClick={() => {
                      setSelectedType("Tous les types");
                      setIsTypeDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Tous les types
                  </button>
                  <button
                    onClick={() => {
                      setSelectedType("Soft Message");
                      setIsTypeDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Soft Message
                  </button>
                  <button
                    onClick={() => {
                      setSelectedType("SMS");
                      setIsTypeDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    SMS
                  </button>
                  <button
                    onClick={() => {
                      setSelectedType("Email");
                      setIsTypeDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Email
                  </button>
                </div>
              </div>
            )}
          </div>
          {/* Status Filter */}
          <div className="relative">
            <button
              onClick={toggleStatusDropdown}
              className={`flex items-center px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap`}
            >
              <span>{selectedStatus}</span>
              <i className="fas fa-chevron-down ml-2"></i>
            </button>
            {isStatusDropdownOpen && (
              <div
                className={`absolute top-full right-0 mt-1 w-48 rounded-md shadow-lg ${
                  isDarkMode ? "bg-[#161B22]" : "bg-white"
                } z-10 border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                }`}
                ref={statusDropdownRef}
              >
                <div className="py-1">
                  <button
                    onClick={() => {
                      setSelectedStatus("Tous les statuts");
                      setIsStatusDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Tous les statuts
                  </button>
                  <button
                    onClick={() => {
                      setSelectedStatus("Envoyé");
                      setIsStatusDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Envoyé
                  </button>
                  <button
                    onClick={() => {
                      setSelectedStatus("Brouillon");
                      setIsStatusDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Brouillon
                  </button>
                </div>
              </div>
            )}
          </div>
          {/* Filter Button */}
          <button
            onClick={handleResetFilter}
            className={`px-4 py-2 rounded-md ${
              isDarkMode
                ? "bg-[#161B22] hover:bg-gray-700"
                : "bg-white hover:bg-gray-100"
            } border ${
              isDarkMode ? "border-gray-700" : "border-gray-300"
            } !rounded-button whitespace-nowrap`}
            title="Réinitialiser"
          >
            <i className="fas fa-filter"></i>
          </button>
        </div>
        {/* View Toggle */}
        <div className="mb-6">
          <div
            className={`inline-flex rounded-md overflow-hidden border ${
              isDarkMode ? "border-gray-700" : "border-gray-300"
            }`}
          >
            <button
              className={`px-4 py-2 ${
                viewMode === "liste"
                  ? isDarkMode
                    ? "bg-gray-700"
                    : "bg-gray-200"
                  : isDarkMode
                  ? "bg-[#161B22]"
                  : "bg-white"
              } !rounded-button whitespace-nowrap`}
              onClick={() => setViewMode("liste")}
            >
              <i className="fas fa-list mr-2"></i>
              Liste
            </button>
            <button
              className={`px-4 py-2 ${
                viewMode === "cartes"
                  ? isDarkMode
                    ? "bg-gray-700"
                    : "bg-gray-200"
                  : isDarkMode
                  ? "bg-[#161B22]"
                  : "bg-white"
              } !rounded-button whitespace-nowrap`}
              onClick={() => setViewMode("cartes")}
            >
              <i className="fas fa-th-large mr-2"></i>
              Cartes
            </button>
          </div>
        </div>
        {/* Communications List View */}
        {viewMode === "liste" && (
          <div
            className={`rounded-lg overflow-hidden border ${
              isDarkMode ? "border-gray-700" : "border-gray-300"
            } min-h-screen-minus-200`}
          >
            <table className="min-w-full divide-y divide-gray-700">
              <thead
                className={`${isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}`}
              >
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Date
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Objet
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Destinataires
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Type
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Statut
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody
                className={`${
                  isDarkMode ? "bg-[#0D1117]" : "bg-white"
                } divide-y ${
                  isDarkMode ? "divide-gray-700" : "divide-gray-200"
                }`}
              >
                {currentMessages.map((message) => (
                  <tr
                    key={message.id}
                    className={`${
                      isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
                    }`}
                  >
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div
                        className={`${
                          isDarkMode ? "text-gray-300" : "text-gray-700"
                        } font-medium text-sm`}
                      >
                        {message.date}
                      </div>
                      <div
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        }`}
                      >
                        {message.heure}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="font-medium">{message.objet}</div>
                      <div
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        } truncate max-w-xs`}
                      >
                        {message.contenu}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div>{message.destinataires}</div>
                      <div
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        }`}
                      >
                        {message.classe}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span
                        className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                          message.type === "Urgent"
                            ? "bg-red-100 text-red-800"
                            : message.type === "Normal"
                            ? "bg-blue-100 text-blue-800"
                            : "bg-green-100 text-green-800"
                        }`}
                      >
                        {message.type}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span
                        className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                          message.statut === "Envoyé"
                            ? "bg-green-100 text-green-800"
                            : "bg-yellow-100 text-yellow-800"
                        }`}
                      >
                        {message.statut}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center">
                      <div className="flex justify-center space-x-3">
                        <button
                          onClick={() => {
                            setSelectedMessage(message);
                            setShowViewMessageModal(true);
                          }}
                          className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap"
                        >
                          <i className="fas fa-eye"></i>
                        </button>
                        <button
                          onClick={() => {
                            setMessageToEdit(message);
                            setShowEditMessageModal(true);
                          }}
                          className="text-green-500 hover:text-green-700 cursor-pointer !rounded-button whitespace-nowrap"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          onClick={() => {
                            setMessageToDelete(message);
                            setShowDeleteModal(true);
                          }}
                          className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap"
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {/* Communications Cards View */}
        {viewMode === "cartes" && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {currentMessages.map((message) => (
              <div
                key={message.id}
                className={`rounded-lg overflow-hidden border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                } shadow-sm`}
              >
                <div
                  className={`p-4 ${
                    isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
                  } border-b ${
                    isDarkMode ? "border-gray-700" : "border-gray-200"
                  }`}
                >
                  <div className="flex justify-between items-center">
                    <div className="font-medium truncate max-w-[200px]">
                      {message.objet}
                    </div>
                    <span
                      className={`px-2 py-1 text-xs font-semibold rounded-full ${
                        message.type === "Urgent"
                          ? "bg-red-100 text-red-800"
                          : message.type === "Normal"
                          ? "bg-blue-100 text-blue-800"
                          : "bg-green-100 text-green-800"
                      }`}
                    >
                      {message.type}
                    </span>
                  </div>
                </div>
                <div
                  className={`p-4 ${isDarkMode ? "bg-[#0D1117]" : "bg-white"}`}
                >
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        }`}
                      >
                        Date:
                      </span>
                      <span>
                        {message.date} - {message.heure}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        }`}
                      >
                        Destinataires:
                      </span>
                      <span className="truncate max-w-[150px]">
                        {message.destinataires}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        }`}
                      >
                        Classe:
                      </span>
                      <span>{message.classe}</span>
                    </div>
                    <div className="flex justify-between">
                      <span
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        }`}
                      >
                        Statut:
                      </span>
                      <span
                        className={`px-2 py-0.5 text-xs font-semibold rounded-full ${
                          message.statut === "Envoyé"
                            ? "bg-green-100 text-green-800"
                            : "bg-yellow-100 text-yellow-800"
                        }`}
                      >
                        {message.statut}
                      </span>
                    </div>
                    {/* {message.statut === "Envoyé" && (
                      <div className="flex justify-between">
                        <span
                          className={`text-sm ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                        >
                          Lecture:
                        </span>
                        <span className="text-sm">
                          Lu: {message.lu} / Non lu: {message.nonLu}
                        </span>
                      </div>
                    )} */}
                  </div>
                  <div className="mt-4 text-sm text-gray-500 mb-4 h-16 overflow-hidden">
                    {message.contenu}
                  </div>
                  <div className="flex justify-between">
                    <button
                      className={`px-3 py-1 rounded text-sm ${
                        isDarkMode
                          ? "bg-blue-900 hover:bg-blue-800"
                          : "bg-blue-100 hover:bg-blue-200"
                      } text-blue-500 !rounded-button whitespace-nowrap`}
                    >
                      <i className="fas fa-eye mr-1"></i> Voir
                    </button>
                    <button
                      className={`px-3 py-1 rounded text-sm ${
                        isDarkMode
                          ? "bg-green-900 hover:bg-green-800"
                          : "bg-green-100 hover:bg-green-200"
                      } text-green-500 !rounded-button whitespace-nowrap`}
                    >
                      <i className="fas fa-edit mr-1"></i>
                    </button>
                    <button
                      className={`px-3 py-1 rounded text-sm ${
                        isDarkMode
                          ? "bg-red-900 hover:bg-red-800"
                          : "bg-red-100 hover:bg-red-200"
                      } text-red-500 !rounded-button whitespace-nowrap`}
                    >
                      <i className="fas fa-trash-alt mr-1"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        {/* Pagination */}
        <div className="mt-6 flex items-center justify-between">
          <div
            className={`text-sm ${
              isDarkMode ? "text-gray-400" : "text-gray-600"
            }`}
          >
            Affichage de {indexOfFirstMessage + 1} à{" "}
            {Math.min(indexOfLastMessage, filteredCommunications.length)} sur{" "}
            {filteredCommunications.length} messages
          </div>
          <div className="flex space-x-2">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`px-3 py-1 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap ${
                currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index + 1}
                onClick={() => handlePageChange(index + 1)}
                className={`px-3 py-1 rounded-md ${
                  currentPage === index + 1
                    ? `${isDarkMode ? "bg-blue-600" : "bg-blue-500"} text-white`
                    : `${
                        isDarkMode
                          ? "bg-[#161B22] hover:bg-gray-700"
                          : "bg-white hover:bg-gray-100"
                      } border ${
                        isDarkMode ? "border-gray-700" : "border-gray-300"
                      }`
                } !rounded-button whitespace-nowrap`}
              >
                {index + 1}
              </button>
            ))}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`px-3 py-1 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap ${
                currentPage === totalPages
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </main>
      {/* View Message Modal */}
      {showViewMessageModal && selectedMessage && (
        <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div
            className={`relative w-full max-w-2xl rounded-lg shadow-lg ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            }`}
          >
            <div
              className={`p-4 border-b ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-between items-center`}
            >
              <h3 className="text-xl font-bold">Détails du message</h3>
              <div className="flex space-x-2">
                <button
                  onClick={() => setShowViewMessageModal(false)}
                  className="text-gray-500 hover:text-gray-700 !rounded-button whitespace-nowrap"
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            </div>
            <div className="p-6">
              <div className="space-y-4">
                <div className="flex justify-between items-start">
                  <div>
                    <h4 className="text-lg font-semibold">
                      {selectedMessage.objet}
                    </h4>
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-600"
                      }`}
                    >
                      {selectedMessage.date} à {selectedMessage.heure}
                    </p>
                  </div>
                  <span
                    className={`px-2 py-1 text-xs font-semibold rounded-full ${
                      selectedMessage.type === "Urgent"
                        ? "bg-red-100 text-red-800"
                        : selectedMessage.type === "Normal"
                        ? "bg-blue-100 text-blue-800"
                        : "bg-green-100 text-green-800"
                    }`}
                  >
                    {selectedMessage.type}
                  </span>
                </div>
                <div
                  className={`p-4 rounded-lg ${
                    isDarkMode ? "bg-[#0D1117]" : "bg-gray-50"
                  }`}
                >
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-600"
                        }`}
                      >
                        Destinataires:
                      </p>
                      <p className="font-medium">
                        {selectedMessage.destinataires}
                      </p>
                    </div>
                    <div>
                      <p
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-600"
                        }`}
                      >
                        Classe:
                      </p>
                      <p className="font-medium">{selectedMessage.classe}</p>
                    </div>
                    <div>
                      <p
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-600"
                        }`}
                      >
                        Statut:
                      </p>
                      <span
                        className={`px-2 py-1 text-xs font-semibold rounded-full ${
                          selectedMessage.statut === "Envoyé"
                            ? "bg-green-100 text-green-800"
                            : "bg-yellow-100 text-yellow-800"
                        }`}
                      >
                        {selectedMessage.statut}
                      </span>
                    </div>
                    {/* <div>
                      <p
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-600"
                        }`}
                      >
                        Statistiques:
                      </p>
                      <p className="font-medium">
                        Lu: {selectedMessage.lu} / Non lu:{" "}
                        {selectedMessage.nonLu}
                      </p>
                    </div> */}
                  </div>
                </div>
                <div>
                  <p
                    className={`text-sm font-medium mb-2 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Contenu du message:
                  </p>
                  <div
                    className={`p-4 rounded-lg ${
                      isDarkMode ? "bg-[#0D1117]" : "bg-gray-50"
                    }`}
                  >
                    {selectedMessage.contenu}
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`p-4 border-t ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-end`}
            >
              <button
                onClick={() => setShowViewMessageModal(false)}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Edit Message Modal */}
      {showEditMessageModal && messageToEdit && (
        <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div
            className={`relative w-full max-w-4xl rounded-lg shadow-lg ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            }`}
          >
            <div
              className={`p-4 border-b ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-between items-center`}
            >
              <h3 className="text-xl font-bold">Modifier le message</h3>
              <button
                onClick={() => setShowEditMessageModal(false)}
                className="text-gray-500 hover:text-gray-700 !rounded-button whitespace-nowrap"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="p-6">
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <div className="flex-3">
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Type de message
                    </label>
                    <div className="flex space-x-4 mb-4">
                      <div className="flex items-center">
                        <input
                          type="radio"
                          value="parents"
                          id="edit-type-normal"
                          name="edit-message-type"
                          className="h-4 w-4 text-blue-600 cursor-pointer focus:ring-blue-500 border-gray-300"
                          defaultChecked={
                            createMessageForm.type_destinateur === "parents"
                          }
                          onChange={handleChangeDestinateur}
                        />
                        <label
                          htmlFor="edit-type-normal"
                          className="ml-2 block text-sm"
                        >
                          Parents
                        </label>
                      </div>
                      <div className="flex items-center">
                        <input
                          type="radio"
                          id="edit-type-urgent"
                          value="personals"
                          name="edit-message-type"
                          className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300"
                          defaultChecked={
                            createMessageForm.type_destinateur === "personals"
                          }
                          onChange={handleChangeDestinateur}
                        />
                        <label
                          htmlFor="edit-type-urgent"
                          className="ml-2 block text-sm"
                        >
                          Personals
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="w-1/5">
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Mode d'envoi
                    </label>
                    <div
                      className={`relative border  ${
                        isDarkMode ? "border-gray-700" : "border-gray-300"
                      } rounded-md`}
                    >
                      <select
                        className={`appearance-none w-full px-3 py-1 rounded-md ${
                          isDarkMode ? "bg-[#0D1117]" : "bg-white"
                        } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        defaultValue={messageToEdit?.destinataires}
                      >
                        {/* <option value="Tous les parents">Soft Message</option> */}
                        <option value="email">Email</option>
                        <option value="sms">SMS</option>
                      </select>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                        <i className="fas fa-chevron-down"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <label
                  className={`block text-sm font-medium mb-1 ${
                    isDarkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Destinataires
                </label>
                <div
                  className={`relative border ${
                    isDarkMode ? "border-gray-700" : "border-gray-300"
                  } rounded-md`}
                >
                  <select
                    className={`appearance-none w-full px-3 py-1 rounded-md ${
                      isDarkMode ? "bg-[#0D1117]" : "bg-white"
                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    defaultValue={messageToEdit?.destinataires}
                  >
                    <option value="Tous les parents">Tous les parents</option>
                    <option value="Parents 6ème A">Parents 6ème A</option>
                    <option value="Parents 6ème B">Parents 6ème B</option>
                    <option value="Parents 5ème A">Parents 5ème A</option>
                    <option value="Parents 5ème B">Parents 5ème B</option>
                    <option value="Parents 4ème B">Parents 4ème B</option>
                    <option value="Parents 4ème C">Parents 4ème C</option>
                    <option value="Parents 3ème A">Parents 3ème A</option>
                    <option value="Parents 3ème C">Parents 3ème C</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                    <i className="fas fa-chevron-down"></i>
                  </div>
                </div>

                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Objet
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2 rounded-md border ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-white border-gray-300"
                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    defaultValue={messageToEdit?.objet}
                  />
                </div>
                <div>
                  <div className="flex items-center justify-between">
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Contenu du message
                    </label>
                    <div className="text-sm text-gray-500">
                      <span id="smsCharCount">0</span> / 160 caractères (SMS)
                    </div>
                  </div>
                  <div
                    className={`border ${
                      isDarkMode ? "border-gray-700" : "border-gray-300"
                    } rounded-md mb-2`}
                  >
                    <div
                      className={`flex items-center space-x-1 px-2 py-1 border-b ${
                        isDarkMode
                          ? "border-gray-700 bg-gray-800"
                          : "border-gray-200 bg-gray-50"
                      }`}
                    >
                      <button
                        className={`p-1 rounded hover:${
                          isDarkMode ? "bg-gray-700" : "bg-gray-200"
                        } !rounded-button whitespace-nowrap`}
                      >
                        <i className="fas fa-bold"></i>
                      </button>
                      <button
                        className={`p-1 rounded hover:${
                          isDarkMode ? "bg-gray-700" : "bg-gray-200"
                        } !rounded-button whitespace-nowrap`}
                      >
                        <i className="fas fa-italic"></i>
                      </button>
                      <button
                        className={`p-1 rounded hover:${
                          isDarkMode ? "bg-gray-700" : "bg-gray-200"
                        } !rounded-button whitespace-nowrap`}
                      >
                        <i className="fas fa-underline"></i>
                      </button>
                      <span className="border-r h-5 mx-1 border-gray-400"></span>
                      <button
                        className={`p-1 rounded hover:${
                          isDarkMode ? "bg-gray-700" : "bg-gray-200"
                        } !rounded-button whitespace-nowrap`}
                      >
                        <i className="fas fa-list-ul"></i>
                      </button>
                    </div>
                    <textarea
                      className={`w-full px-3 py-2 rounded-b-md ${
                        isDarkMode ? "bg-[#0D1117]" : "bg-white"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500 border-none`}
                      rows={5}
                      defaultValue={messageToEdit?.contenu}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`p-4 border-t ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-end space-x-3`}
            >
              <button
                onClick={() => setShowEditMessageModal(false)}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                Annuler
              </button>
              <button
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-blue-500 hover:bg-blue-600"
                } text-white !rounded-button whitespace-nowrap`}
              >
                Enregistrer les modifications
              </button>
              <button
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-green-600 hover:bg-green-700"
                    : "bg-green-500 hover:bg-green-600"
                } text-white !rounded-button whitespace-nowrap`}
              >
                Envoyer
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Delete Confirmation Modal */}
      {showDeleteModal && messageToDelete && (
        <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div
            className={`relative w-full max-w-md rounded-lg shadow-lg ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            }`}
          >
            <div
              className={`p-4 border-b ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              }`}
            >
              <h3 className="text-xl font-bold text-red-500">
                Confirmer la suppression
              </h3>
            </div>
            <div className="p-6">
              <div className="flex items-center mb-4">
                <i className="fas fa-exclamation-triangle text-2xl text-red-500 mr-3"></i>
                <p
                  className={`${
                    isDarkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Êtes-vous sûr de vouloir supprimer ce message ? Cette action
                  est irréversible.
                </p>
              </div>
              <div
                className={`p-3 rounded-md ${
                  isDarkMode ? "bg-[#0D1117]" : "bg-gray-50"
                }`}
              >
                <p className="font-medium">{messageToDelete.objet}</p>
                <p
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-500"
                  } mt-1`}
                >
                  Envoyé le {messageToDelete.date} à {messageToDelete.heure}
                </p>
              </div>
            </div>
            <div
              className={`p-4 border-t ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-end space-x-3`}
            >
              <button
                onClick={() => setShowDeleteModal(false)}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                Annuler
              </button>
              <button
                onClick={() => {
                  // Here you would typically make an API call to delete the message
                  // For now, we'll just close the modal and show a notification
                  setShowDeleteModal(false);
                  showNotification("suppression faite");
                  // setShowNotification(true);
                  // setTimeout(() => setShowNotification(false), 3000);
                }}
                className="px-4 py-2 rounded-md bg-red-500 hover:bg-red-600 text-white !rounded-button whitespace-nowrap"
              >
                Confirmer la suppression
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Success Notification */}
      {/* {showNotification && (
        <div className="fixed bottom-4 right-4 z-50">
          <div
            className={`${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            } rounded-lg shadow-lg p-4 flex items-center space-x-3 border ${
              isDarkMode ? "border-gray-700" : "border-gray-200"
            }`}
          >
            <i className="fas fa-check-circle text-green-500"></i>
            <p>Message supprimé avec succès</p>
          </div>
        </div>
      )} */}
      {/* New Message Modal */}
      {showNewMessageModal && (
        <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div
            className={`relative w-full max-w-4xl rounded-lg shadow-lg ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            }`}
          >
            <div
              className={`p-4 border-b ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-between items-center`}
            >
              <h3 className="text-xl font-bold">Nouveau communiqué</h3>
              <button
                onClick={() => {
                  setShowNewMessageModal(false);
                  setcreateMessageForm({
                    objet: "",
                    contenu: "",
                    type_destinateur: "parents",
                    destinateur_id: "",
                    annee_scolaire_id: "",
                    type_diffuison: "",
                    canal: "email",
                    type_request: null,
                    status: 0,
                  });
                }}
                className="text-gray-500 hover:text-gray-700 !rounded-button whitespace-nowrap"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="p-6">
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <div className="flex-3">
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Type de message
                    </label>
                    <div className="flex space-x-4 mb-4">
                      <div className="flex items-center">
                        <input
                          type="radio"
                          id="edit-type-normal"
                          name="edit-message-type"
                          value="parents"
                          className="h-4 w-4 text-blue-600 cursor-pointer focus:ring-blue-500 border-gray-300"
                          defaultChecked={
                            createMessageForm.type_destinateur === "parents"
                          }
                          onChange={(e) => {
                            setcreateMessageForm((prev) => ({
                              ...prev,
                              type_destinateur: e.target.value,
                              destinateur_id: "",
                            }));
                          }}
                        />
                        <label
                          htmlFor="edit-type-normal"
                          className="ml-2 block text-sm"
                        >
                          Tous les parents
                        </label>
                      </div>
                      <div className="flex items-center">
                        <input
                          type="radio"
                          id="edit-type-normal"
                          name="edit-message-type"
                          value="parents_class"
                          className="h-4 w-4 text-blue-600 cursor-pointer focus:ring-blue-500 border-gray-300"
                          defaultChecked={
                            createMessageForm.type_destinateur ===
                            "parents_class"
                          }
                          onChange={(e) => {
                            setcreateMessageForm((prev) => ({
                              ...prev,
                              type_destinateur: e.target.value,
                              destinateur_id: "",
                            }));
                          }}
                        />
                        <label
                          htmlFor="edit-type-normal"
                          className="ml-2 block text-sm"
                        >
                          Parents par classe
                        </label>
                      </div>
                      <div className="flex items-center">
                        <input
                          type="radio"
                          id="edit-type-normal"
                          value="single_parent"
                          name="edit-message-type"
                          className="h-4 w-4 text-blue-600 cursor-pointer focus:ring-blue-500 border-gray-300"
                          defaultChecked={
                            createMessageForm.type_destinateur ===
                            "single_parent"
                          }
                          onChange={handleChangeDestinateur}
                        />
                        <label
                          htmlFor="edit-type-normal"
                          className="ml-2 block text-sm"
                        >
                          Un parent
                        </label>
                      </div>
                      <span className="ml-5">|</span>
                      <div className="flex items-center">
                        <input
                          type="radio"
                          id="edit-type-urgent"
                          value="personals"
                          name="edit-message-type"
                          className="h-4 w-4 text-red-600 cursor-pointer focus:ring-red-500 border-gray-300"
                          defaultChecked={
                            createMessageForm.type_destinateur === "personals"
                          }
                          onChange={handleChangeDestinateur}
                        />
                        <label
                          htmlFor="edit-type-urgent"
                          className="ml-2 block text-sm"
                        >
                          Tous les personnels
                        </label>
                      </div>
                      <div className="flex items-center">
                        <input
                          type="radio"
                          id="edit-type-urgent"
                          value="single_personal"
                          name="edit-message-type"
                          className="h-4 w-4 text-red-600 cursor-pointer focus:ring-red-500 border-gray-300"
                          defaultChecked={
                            createMessageForm.type_destinateur ===
                            "single_personal"
                          }
                          onChange={handleChangeDestinateur}
                        />
                        <label
                          htmlFor="edit-type-urgent"
                          className="ml-2 block text-sm"
                        >
                          Un personnel
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="w-4/10">
                    <label
                      className={`block text-sm font-sm mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Mode d'envoi
                    </label>
                    <div
                      className={`relative border  ${
                        isDarkMode ? "border-gray-700" : "border-gray-300"
                      } rounded-md`}
                    >
                      <select
                        className={`appearance-none w-full px-3 py-1 rounded-md ${
                          isDarkMode ? "bg-[#0D1117]" : "bg-white"
                        } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        onChange={(e) => {
                          setcreateMessageForm((prev) => ({
                            ...prev,
                            canal: e.target.value as "sms" | "email",
                          }));
                        }}
                      >
                        {/* <option value="">selectionner</option> */}
                        <option value="email">Email</option>
                        <option value="sms">SMS</option>
                      </select>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                        <i className="fas fa-chevron-down"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <label
                  className={`block text-sm font-medium mb-1 ${
                    isDarkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Destinataires
                </label>
                <div
                  className={`relative border ${
                    isDarkMode ? "border-gray-700" : "border-gray-300"
                  } rounded-md`}
                >
                  {/* sms to all parents=> */}
                  {/* sms to one parent=> */}
                  {/* sms to parents by classe*/}
                  {/* sms to all personals=> */}
                  {/* sms to one personnel=> */}

                  {/* email to all parents=> */}
                  {/* email to one parent=> */}
                  {/* email to parents by classe*/}
                  {/* email to all personals=> */}
                  {/* email to one personnel=> */}

                  {/* softMessage to all parents=> */}
                  {/* softMessage to one parent=> */}
                  {/* softMessage to parents by classe*/}
                  {/* softMessage to all personals=> */}
                  {/* softMessage to one personnel=> */}

                  {createMessageForm.type_destinateur === "parents" && (
                    <select
                      className={`appearance-none w-full px-3 py-1 rounded-md ${
                        isDarkMode ? "bg-[#0D1117]" : "bg-white"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      onChange={(e) => {
                        setcreateMessageForm((prev) => ({
                          ...prev,
                          destinateur_id: e.target.value,
                        }));
                      }}
                    >
                      <option value="">Selectionner destinateur</option>
                      <option value="all">Tous les parents</option>
                    </select>
                  )}
                  {createMessageForm.type_destinateur === "parents_class" && (
                    <select
                      className={`appearance-none w-full px-3 py-1 rounded-md ${
                        isDarkMode ? "bg-[#0D1117]" : "bg-white"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      onChange={(e) => {
                        setcreateMessageForm((prev) => ({
                          ...prev,
                          destinateur_id: e.target.value,
                        }));
                      }}
                    >
                      <option value="">Selectionner destinateur</option>
                      {classesArray.map((classe) => (
                        <option value={classe.id}>
                          {capitalizeFirstLetter(classe.designation)}
                        </option>
                      ))}
                    </select>
                  )}
                  {createMessageForm.type_destinateur === "single_parent" && (
                    <select
                      className={`appearance-none w-full px-3 py-1 rounded-md ${
                        isDarkMode ? "bg-[#0D1117]" : "bg-white"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      onChange={(e) => {
                        setcreateMessageForm((prev) => ({
                          ...prev,
                          destinateur_id: e.target.value,
                        }));
                      }}
                    >
                      <option value="">Selectionner destinateur</option>
                      {affectedStudents
                        .sort((a, b) => a?.nom.localeCompare(b?.nom))
                        .map((student, index) => (
                          <option value={student.parentId}>
                            {index + 1} - {capitalizeFirstLetter(student.noms)}
                          </option>
                        ))}
                    </select>
                  )}

                  {createMessageForm.type_destinateur === "personals" && (
                    <select
                      className={`appearance-none w-full px-3 py-1 rounded-md ${
                        isDarkMode ? "bg-[#0D1117]" : "bg-white"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      onChange={(e) => {
                        setcreateMessageForm((prev) => ({
                          ...prev,
                          destinateur_id: e.target.value,
                        }));
                      }}
                    >
                      <option value="">Selectionner destinateur</option>
                      <option value="all">Tous les personnels</option>
                    </select>
                  )}
                  {createMessageForm.type_destinateur === "single_personal" && (
                    <select
                      className={`appearance-none w-full px-3 py-1 rounded-md ${
                        isDarkMode ? "bg-[#0D1117]" : "bg-white"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      onChange={(e) => {
                        setcreateMessageForm((prev) => ({
                          ...prev,
                          destinateur_id: e.target.value,
                        }));
                      }}
                    >
                      <option value="">Selectionner destinateur</option>
                      {affectedPersonals.map((personal, index) => (
                        <option key={index} value={personal.personalId}>
                          {capitalizeFirstLetter(personal.noms)}
                        </option>
                      ))}
                    </select>
                  )}
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                    <i className="fas fa-chevron-down"></i>
                  </div>
                </div>
                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Objet
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2 rounded-md border ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-white border-gray-300"
                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    placeholder="Objet du message"
                    value={createMessageForm.objet}
                    onChange={(e) =>
                      setcreateMessageForm((prev) => ({
                        ...prev,
                        objet: e.target.value,
                      }))
                    }
                  />
                </div>
                <div>
                  <div className="flex items-center justify-between">
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Contenu du message
                    </label>
                    <div className="text-sm text-gray-500">
                      <span id="smsCharCount">0</span> / 160 caractères (SMS)
                    </div>
                  </div>
                  <div
                    className={`border ${
                      isDarkMode ? "border-gray-700" : "border-gray-300"
                    } rounded-md mb-2`}
                  >
                    <div
                      className={`flex items-center space-x-1 px-2 py-1 border-b ${
                        isDarkMode
                          ? "border-gray-700 bg-gray-800"
                          : "border-gray-200 bg-gray-50"
                      }`}
                    >
                      <button
                        className={`p-1 rounded hover:${
                          isDarkMode ? "bg-gray-700" : "bg-gray-200"
                        } !rounded-button whitespace-nowrap`}
                      >
                        <i className="fas fa-italic"></i>
                      </button>
                      <button
                        className={`p-1 rounded hover:${
                          isDarkMode ? "bg-gray-700" : "bg-gray-200"
                        } !rounded-button whitespace-nowrap`}
                      >
                        <i className="fas fa-underline"></i>
                      </button>
                      <span className="border-r h-5 mx-1 border-gray-400"></span>
                      <button
                        className={`p-1 rounded hover:${
                          isDarkMode ? "bg-gray-700" : "bg-gray-200"
                        } !rounded-button whitespace-nowrap`}
                      >
                        <i className="fas fa-list-ul"></i>
                      </button>

                      <span className="border-r h-5 mx-1 border-gray-400"></span>
                    </div>
                    <textarea
                      placeholder="Ecrire..."
                      className={`w-full px-3 py-2 rounded-b-md ${
                        isDarkMode ? "bg-[#0D1117]" : "bg-white"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500 border-none`}
                      rows={5}
                      value={createMessageForm.contenu}
                      onChange={(e) =>
                        setcreateMessageForm((prev) => ({
                          ...prev,
                          contenu: e.target.value,
                        }))
                      }
                      // defaultValue={messageToEdit.contenu}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`p-4 border-t ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-end space-x-3`}
            >
              <button
                onClick={() => {
                  setShowNewMessageModal(false);
                  setcreateMessageForm({
                    objet: "",
                    contenu: "",
                    type_destinateur: "parents",
                    destinateur_id: "",
                    annee_scolaire_id: "",
                    type_diffuison: "",
                    canal: "email",
                    type_request: null,
                    status: 0,
                  });
                }}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                Annuler
              </button>
              <button
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-blue-500 hover:bg-blue-600"
                } text-white !rounded-button whitespace-nowrap`}
              >
                Enregistrer brouillon
              </button>
              <button
                disabled={isPending}
                onClick={handleSendMessage}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-green-600 hover:bg-green-700"
                    : "bg-green-500 hover:bg-green-600"
                } text-white !rounded-button whitespace-nowrap ${
                  isPending ? "cursor-not-allowed" : ""
                }`}
              >
                {isPending ? "Envoie en cours..." : "Envoyer message"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== NOTIFICATION ===== */}
      {notification && (
        <div
          className={`fixed bottom-4 right-4 px-6 py-3 rounded-lg text-white shadow-lg transition-all duration-500 ${
            notification.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {notification.message}
        </div>
      )}
    </div>
  );
};
export default Message;
